function assertNever(x: never): never {
  throw new Error(`Unexpected type: ${x}`);
}

const isTruthy = <T>(x: T | null | undefined): x is T => !!x;

const isNotNull = <T>(x: T): x is NonNullable<T> => x != null;

const isDefined = <T>(x: T | null | undefined): x is T => x !== null && x !== undefined;

export { assertNever, isTruthy, isNotNull, isDefined };
